<template>
  <Modal title="添加老师" v-model="visible">
    <Form ref="tchForm" class="form" :label-width="80"
      :model="tchParam" :rules="ruleTch" >
      <Row>
        <Col :span="11" >
          <Form-item label="名字" prop="firstName">
            <Input
              v-model="tchParam.firstName"></Input>
          </Form-item>
        </Col>
        <Col :span="11" >
          <Form-item label="姓氏" prop="lastName">
            <Input
              v-model="tchParam.lastName"></Input>
          </Form-item>
        </Col>
        <Col :span="11" >
        <Form-item label=" 区号/地域 " prop="areaNum">
          <phone-area-select v-model="tchParam.areaNum" @on-change="onAreaNumChange"></phone-area-select>
        </Form-item>
        </Col>
        <Col :span="11" >
          <Form-item label="手机" prop="account">
            <Input
              v-model="tchParam.account"></Input>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="密码" prop="password">
            <Input v-model="tchParam.password" type="password"></Input>
          </Form-item>
        </Col>
        <Col :span="11" >
          <Form-item label="国家" prop="country">
            <Select v-model="tchParam.country" filterable transfer>
              <Option v-for="item in countryList"
                :value="item.code" :key="item.code">{{ item.cn }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="性别" prop="sex">
            <Select v-model.number="tchParam.sex" clearable transfer>
              <Option v-for="item in $constant.sex"
                :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="星级" prop="star">
            <Input v-model="tchParam.star" ></Input>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="上课权限" prop="type">
            <Select v-model.number="tchParam.type" transfer>
              <Option v-for="item in $constant.teacherType"
                :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="状态" prop="status">
            <Select v-model.number="tchParam.status">
              <Option v-for="item in $constant.teacherStatus"
                :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="类型" prop="category">
            <Select v-model.number="tchParam.category" transfer>
              <Option v-for="item in $constant.teacherCategory.filter(function (c) { return c.code !== 6 })"
                :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="授课类型" prop="tchType">
            <Select v-model.number="tchParam.tchType" transfer>
              <Option v-for="item in $constant.tchType"
                :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="是否有试听课权限" prop="isAudition">
            <Select v-model="tchParam.isAudition" clearable>
              <Option v-for="item in $constant.yn"
                :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="11">
        <Form-item label="时薪" prop="salary">
            <Input v-model.number="tchParam.salary"></Input>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingInsertTch" @click="insert">添加</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'TchInsertModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      user: {
        type: Object
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let self = this
      return {
        visible: this.value,
        loadingInsertTch: false,
        countryList: null,
        tchParam: {
          type: 1,
          status: 0,
          country: 'Nationallity',
          sex: 1,
          password: '',
          category: 0,
          isAudition: '',
          tchType: 0,
          areaNum: '',
          salary: '',
        },
        ruleTch: {
          firstName: [
            { type: 'string', required: true, message: '名字不能为空', trigger: 'blur' },
            { type: 'string', max: 20, message: '名字不要超过20个字符', trigger: 'blur' }
          ],
          lastName: [
            { type: 'string', max: 20, message: '姓氏不要超过20个字符', trigger: 'blur' }
          ],
          areaNum: [
            { type: 'number', required: true, message: '请选择区号', trigger: 'blur' }
          ],
          account: [
            { required: true, message: '手机不能为空', trigger: 'blur' },
            { validator (rule, value, callback, source, options) {
              let errors = []
              if (value === '') {
                callback(errors)
                return
              }
              let telNumber = ''
              let num = parseInt(self.tchParam.areaNum)
              if (num === 86) {
                telNumber = value
              } else {
                telNumber = '00' + num + '-' + value
              }
              if (!telNumber) {
                return
              }
              self.$http.post('/tch/queryByEmail?account=' + telNumber).then(function (res) {
                if (res && res.data) {
                  errors.push('手机号已存在')
                }
                callback(errors)
                return
              }).catch(function (e) {
                errors.push('系统异常')
                callback(errors)
                return
              })
            } }
          ],
          password: [
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { type: 'string', min: 6, max: 16, message: '密码应为6到16位的字符', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      onAreaNumChange (val) {
        if (val) {
          this.tchParam.areaNum = val
        }
      },
      insert () {
        let self = this
        self.loadingInsertTch = true
        self.$refs.tchForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingInsertTch = false
            return
          }
          self.$http.post('/tch/bopsInsert', self.tchParam).then(function (res) {
            if (res && res.data > 0) {
              self.successCallback()
              self.visible = false
              self.$Message.success('提交成功!')
            }
            self.visible = false
          }).catch(function (e) {
            self.loadingInsertTch = false
          })
        })
      },
      loadCountry () {
        let self = this
        if (self.countryList) {
          return
        }
        self.$http.get('/country/list').then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.countryList = res.data
        })
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.loadCountry()
          this.$refs['tchForm'].resetFields()
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TchInsertModal.vue?5d32c806